<template>
  <div class="select-customer-widget">
    <!-- company-profile display -->
    <div class="company-profile-container" v-animate-css="'fadeIn'">
      <div class="company-profile-body">
        <div class="ribbon">
          <div class="title">
            <h4>Client</h4>
          </div>
          <button
            class="send-by-email"
            v-if="!show_send_via_email"
            @click="show_send_via_email = !show_send_via_email"
          >
            Send via email
          </button>
          <button
            class="send-by-email"
            v-else
            @click="show_send_via_email = !show_send_via_email"
          >
            Send to existing client
          </button>
        </div>
        <div class="search-add-btn-widget" v-if="!show_send_via_email">
          <div class="search-widget">
            <img src="@/assets/icons/search.svg" alt />
            <input
              v-model="search_member_input"
              @keyup="searchCompanyMember()"
              type="text"
              placeholder="Type in to Search…"
            />
          </div>
        </div>
        <ul
          class="consultants-items"
          v-if="customers.length > 0 && !show_send_via_email"
        >
          <li class="consultants-starter">
            <div class="consultants-item-header">
              <input
                type="checkbox"
                v-model="select_all"
                class="select-checkbox"
              />
              <label>Select all Client</label>
            </div>
          </li>
          <li
            class="consultants-item"
            v-for="(item, index) in customers"
            :key="index"
          >
            <panel-expand>
              <template v-slot:header="{}">
                <div class="consultants-item-header">
                  <div class="consultants-item-brand">
                    <input
                      v-model="item.checked"
                      type="checkbox"
                      class="select-checkbox"
                    />
                    <img
                      v-if="item.profile_picture"
                      :src="$fullUrl('images/profiles/' + item.profile_picture)"
                      alt
                    />
                    <img v-else src="@/assets/icons/logo_avatar.svg" alt />
                  </div>
                  <div class="content">
                    <div class="title-row">
                      <label
                        >{{ item.first_name | validate }}
                        {{ item.last_name | validate }}</label
                      >
                    </div>
                    <div class="options"></div>
                  </div>
                </div>
              </template>
            </panel-expand>
          </li>
        </ul>
        <div class="empty-widget" v-else-if="!show_send_via_email">
          <div class="empty-widgetheader"></div>
          <div class="empty-widget-body">
            <p>No client found</p>
          </div>
        </div>

        <!-- Send via email form -->
        <div class="send-via-email" v-else>
          <input
            type="text"
            v-model="form.company_name"
            class="input email-input"
            placeholder="Company name"
          />
          <input
            type="email"
            v-model="form.email"
            class="input email-input"
            placeholder="Email Address"
          />
        </div>
        <!-- End of form -->

        <div class="options" :class="{ flex_start: show_send_via_email }">
          <consultfied-button
            v-if="customers.length > 0 && !show_send_via_email"
            :loading="loading"
            @click="sendPitch()"
            class="assign-btn"
            >Send</consultfied-button
          >

          <consultfied-button
            v-else
            :loading="loading"
            @click="sendPitchViaEmail()"
            class="assign-btn"
            >Send Email</consultfied-button
          >

          <button class="close-btn" @click="closeModal()">Cancel</button>
        </div>
      </div>
    </div>
    <!-- End -->
  </div>
</template>

<script>
import panelExpand from "@/components/Partials/panelExpand";
import dropdownMenu from "@/components/Partials/dropdownMenu";
import appDialog from "@/components/Dialog/AppDialog.vue";
import ManageConsultant from "@/components/Company/ManageConsultant.vue";
import consultfiedButton from "@/components/helper/consultfiedButton.vue";
import { eventBus } from "@/main";
import { mapGetters } from "vuex";
export default {
  name: "consultants",
  components: {
    panelExpand,
    dropdownMenu,
    appDialog,
    ManageConsultant,
    consultfiedButton,
  },
  props: ["value"],
  data: () => {
    return {
      form: {
        id: null,
        company_name: "",
        email: "",
      },
      user: {
        company_info: {},
        manager_info: {},
        manager_profile: {},
        consultants: [],
      },
      show_send_via_email: false,
      search_member_input: "",
      selected_id: null,
      select_all: false,
      customers: [],
      form_field: {
        id: null,
        company_name: "",
        customers: [],
      },
      loading: false,
    };
  },
  mounted() {
    let vm = this;
    vm.getAllStartData();
    vm.getAllCustomerData();
  },
  computed: {},
  watch: {
    select_all: function (new_val) {
      let vm = this;
      if (new_val) {
        vm.customers.forEach((item) => {
          eventBus.$set(item, "checked", true);
        });
      } else {
        vm.customers.forEach((item) => {
          eventBus.$set(item, "checked", false);
        });
      }
    },
  },
  methods: {
    sendPitchViaEmail() {
      let vm = this;
      vm.loading = true;
      vm.form.id = vm.value.id;
      if (vm.validateEmail(vm.form.email)) {
        vm.$store
          .dispatch("COMPANY_SEND_PITCH_VIA_EMAIL", vm.form)
          .then((responce) => {
            vm.loading = false;
            vm.$notify({
              group: "status",
              title: "Message",
              text: "Your pitch was now sent",
              type: "success",
              duration: 3000,
            });
            vm.$emit("onClose", null);
          })
          .catch((error) => {
            vm.loading = false;
            vm.$notify({
              group: "status",
              title: "Error message",
              text: "Error while sending pitch",
              type: "warn",
              duration: 3000,
            });
            console.log(error);
          });
      } else {
        vm.$notify({
          group: "status",
          title: "Error message",
          text: "Invalid email",
          type: "warn",
          duration: 3000,
        });
        vm.loading = false;
      }
    },
    sendPitch() {
      let vm = this;
      vm.loading = true;
      vm.form_field.id = vm.value.id;
      vm.form_field.company_name = vm.user.company_info.company_name;
      vm.customers.forEach((item) => {
        if (item.checked) {
          vm.form_field.customers.push(item.id);
        }
      });
      if (vm.form_field.customers.length > 0) {
        vm.$store
          .dispatch("COMPANY_SEND_PITCH", vm.form_field)
          .then((responce) => {
            vm.loading = false;
            vm.$notify({
              group: "status",
              title: "Message",
              text: "Your pitch was now sent",
              type: "success",
              duration: 3000,
            });
            vm.$emit("onClose", null);
          })
          .catch((error) => {
            vm.loading = false;
            vm.$notify({
              group: "status",
              title: "Error message",
              text: "Error while sending pitch",
              type: "warn",
              duration: 3000,
            });
            console.log(error);
          });
      } else {
        vm.$notify({
          group: "status",
          title: "Error message",
          text: "No client selected",
          type: "warn",
          duration: 3000,
        });
        vm.loading = false;
      }
    },
    validateEmail(email) {
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },
    closeModal() {
      let vm = this;
      vm.$emit("onClose", null);
    },
    searchCompanyMember() {
      let vm = this;
      let query = vm.search_member_input;
      if (vm.search_member_input) {
        vm.$store
          .dispatch("SEARCH_CUSTOMERS_MEMBERS", { query: query })
          .then((responce) => {
            vm.customers = responce.data;
            vm.customers.forEach((item) => {
              eventBus.$set(item, "checked", false);
            });
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        vm.getAllStartData();
      }
    },
    getAllCustomerData() {
      let vm = this;
      vm.$store
        .dispatch("GET_CUSTOMERS")
        .then((responce) => {
          vm.customers = responce.data;
        })
        .catch((error) => {});
    },
    getAllStartData() {
      let vm = this;
      vm.$store
        .dispatch("GET_ME_USER_COMPANY")
        .then((responce) => {
          vm.user = responce.data;
          vm.form.company_name = vm.user.company_info.company_name;
          let consultant_data = vm.processSkills(vm.user.consultants);
          eventBus.$set(vm.user, "consultants", consultant_data);
        })
        .catch((error) => {});
    },
  },
};
</script>
<style lang="scss" scoped>
.select-customer-widget {
  padding-top: 76px;
  display: flex;
  justify-content: center;
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  overflow-y: auto;
  background: rgba(0, 0, 0, 0.4);
  z-index: 999;
  @media (min-width: 300px) and (max-width: 630px) {
    padding-top: 54px;
  }
  .company-profile-container {
    padding: 1px;
    width: 800px;
    border-radius: 5px;
    background: #fff;
    margin-bottom: 20px;
    display: inline-table;
    min-height: 500px;
    @media (min-width: 300px) and (max-width: 630px) {
      width: 100%;
      padding-bottom: 42px;
    }
    .company-profile-body {
      .ribbon {
        display: flex;
        padding: 15px 20px;
        justify-content: space-between;
        .send-by-email {
          color: #1885ad;
          font-style: italic;
          background: transparent;
          border: none;
          outline: none;
          cursor: pointer;
        }
      }
      .search-add-btn-widget {
        padding: 15px 20px;
        display: grid;
        grid-template-columns: 100%;
        grid-column-gap: 20px;
        .search-widget {
          border: 1px solid #ccc;
          height: 45px;
          display: flex;
          align-items: center;
          padding: 0px 10px;
          border-radius: 5px;
          img {
            width: 25px;
            height: 25px;
          }
          input {
            height: 43px;
            width: 100%;
            padding-left: 15px;
            outline: none;
            border: none;
          }
        }
        .reflesh-btn {
          width: 100px;
          height: 45px;
          background: transparent;
          border-radius: 5px;
          opacity: 1;
          color: #1885ad;
          display: flex;
          align-items: center;
          justify-content: center;
          border: 1px solid #1885ad;
        }
        .add-btn {
          width: 191px;
          height: 45px;
          background: #1885ad 0% 0% no-repeat padding-box;
          border-radius: 5px;
          opacity: 1;
          color: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          img {
            margin-left: 10px;
          }
        }
      }
      ul.consultants-items {
        padding: 0px 20px;
        padding-bottom: 20px;
        list-style: none;
        height: 500px;
        overflow-y: auto;
        .consultants-starter {
          margin-bottom: 6px;
          .consultants-item-header {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            align-items: center;
            padding: 16px 0px;
            label {
              color: #000000;
              font-family: "AvenirBook";
              font-size: 14px;
            }
            .select-checkbox {
              height: 15px;
              margin-right: 10px;
              margin-top: -1px;
            }
          }
          p {
            color: #131313;
            font-family: "AvenirBook";
          }
        }
        .consultants-item {
          background: #f5f5f5 0% 0% no-repeat padding-box;
          border-radius: 5px;
          margin-bottom: 10px;
          .consultants-item-header {
            display: grid;
            padding: 0px 4px;
            grid-template-columns: 90px calc(98% - 90px);
            grid-column-gap: 20px;
            .consultants-item-brand {
              display: flex;
              justify-content: center;
              align-items: center;
              width: 90px;
              height: 90px;
              padding-top: 10px;
              padding-bottom: 10px;
              .select-checkbox {
                margin-right: 10px;
              }
              img {
                width: 70px;
                height: 70px;
                border-radius: 50%;
                object-fit: cover;
              }
            }
            .content {
              display: flex;
              width: 100%;
              align-items: center;
              padding-right: 15px;
              .title-row {
                font-family: "AvenirBook";
                label {
                  display: block;
                  font-size: 14px;
                  font-family: "AvenirBlack";
                  margin-bottom: 1px;
                  font-weight: 800;
                }
                span {
                  color: #808080;
                  font-family: "AvenirBook";
                  font-size: 13px;
                  margin-bottom: 6px;
                }
              }
              .options {
                display: flex;
                align-items: flex-end;
                flex-direction: column;
                .date {
                  color: #808080;
                  font-family: "AvenirBook";
                  font-size: 13px;
                }
                .status {
                  color: #000;
                  font-family: "AvenirBook";
                  font-size: 13px;
                }
                .toogle-panel-btn {
                  width: 19px;
                  padding: 0;
                  height: 22px;
                  font-size: 20px;
                  position: relative;
                  top: -3px;
                  right: -5px;
                }
              }
            }
            .toogle-panel-btn {
              padding: 1px 40px;
              font-size: 30px;
              background: transparent;
              border: none;
              outline: none;
              cursor: pointer;
              color: #ccc;
            }
          }
          .consultants-item-body {
            padding: 10px;
            .consultants-info {
              h5 {
                text-align: left;
                color: #6e6e6e;
                font-size: 14px;
              }
              p {
                text-align: left;
                color: #000;
                font-size: 13px;
                font-weight: 800;
              }

              .skills-widget {
                .skills_content__wrapper {
                  display: grid;
                  grid-template-columns: 1fr 1fr 1fr;
                  grid-column-gap: 10px;
                  margin-bottom: 10px;
                  @media (min-width: 300px) and (max-width: 630px) {
                    grid-template-columns: 1fr;
                  }
                  .skill_box {
                    min-width: 0;
                    display: flex;
                    flex-direction: column;
                    width: 100%;
                    background: #fff;
                    border-radius: 5px;
                    margin-bottom: 15px;
                    .skill_box_header {
                      border-bottom: 2px solid #f5f5f5;
                      height: 50px;
                      display: flex;
                      align-items: center;
                      justify-content: space-around;
                      padding: 0px 15px;
                      label {
                        color: #0884af;
                        width: 100%;
                        font-size: 15px;
                        font-weight: 800;
                      }
                    }
                    .skill_box_body {
                      padding: 0px 15px;
                      .empty-skills {
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        height: 200px;
                        justify-content: center;
                        p {
                          text-align: center;
                          margin-bottom: 20px;
                          color: #8d8d8d;
                        }
                        button {
                          width: 133px;
                          height: 36px;
                          background: #1890a9 0% 0% no-repeat padding-box;
                          border-radius: 5px;
                          color: #fff;
                        }
                      }
                      .row__item {
                        margin-top: 10px;
                        display: flex;
                        margin-bottom: 10px;
                        justify-content: space-between;
                        width: 100%;
                        span {
                          color: #000000;
                          font-weight: normal;
                          margin-top: 2px;
                          font-size: 14px;
                          font-weight: 800;
                        }
                      }
                    }
                  }
                }
                .next_skills_content__wrapper {
                  display: grid;
                  grid-template-columns: 1fr 1fr;
                  grid-column-gap: 10px;
                  @media (min-width: 300px) and (max-width: 630px) {
                    grid-template-columns: 1fr;
                  }
                  .skill_box {
                    min-width: 0;
                    display: flex;
                    flex-direction: column;
                    width: 100%;
                    background: #fff;
                    border-radius: 5px;
                    margin-bottom: 15px;
                    .skill_box_header {
                      border-bottom: 2px solid #f5f5f5;
                      height: 50px;
                      display: flex;
                      align-items: center;
                      justify-content: space-around;
                      padding: 0px 15px;
                      label {
                        color: #0884af;
                        width: 100%;
                        font-size: 15px;
                        font-weight: 800;
                      }
                    }
                    .skill_box_body {
                      padding: 0px 15px;
                      .empty-skills {
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        height: 200px;
                        justify-content: center;
                        p {
                          text-align: center;
                          margin-bottom: 20px;
                          color: #8d8d8d;
                        }
                        button {
                          width: 133px;
                          height: 36px;
                          background: #1890a9 0% 0% no-repeat padding-box;
                          border-radius: 5px;
                          color: #fff;
                        }
                      }
                      .row__item {
                        margin-top: 10px;
                        display: flex;
                        margin-bottom: 10px;
                        justify-content: space-between;
                        width: 100%;
                        span {
                          color: #000000;
                          font-weight: normal;
                          margin-top: 2px;
                          font-size: 14px;
                          font-weight: 800;
                        }
                      }
                    }
                  }
                }
              }
            }
            .consultants-item-body-option {
              display: flex;
              justify-content: flex-end;
              .toogle-panel-btn {
                padding: 1px 9px;
                font-size: 30px;
                background: transparent;
                border: none;
                outline: none;
                cursor: pointer;
                color: #ccc;
                height: 36px;
                width: 19px;
                padding: 0;
                height: 22px;
                font-size: 20px;
                position: relative;
                top: -3px;
                right: -5px;
              }
            }
          }
        }
      }
      .empty-widget {
        background: #fff;
        padding: 20px;
        .empty-widget-body {
          height: 350px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          padding: 0px 200px;
          p {
            text-align: center;
          }
          .add-btn {
            width: 180px;
            height: 45px;
            background: #1890a9 0% 0% no-repeat padding-box;
            border-radius: 4px;
            color: #fff;
            outline: none;
            margin-right: 20px;
            display: center;
            justify-content: center;
          }
        }
      }
      .send-via-email {
        padding: 0px 20px;
        .input {
          width: 500px !important;
          height: 45px;
          background: #fcfcfc;
          border: 1px solid #ccc;
          border-radius: 5px;
          padding: 0px 20px;
          margin-bottom: 20px;
        }
      }
      .options {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 20px 20px;
        height: 70px;
        transition: 500ms ease-in-out;
        &.flex_start {
          justify-content: flex-start;
          transition: 500ms ease-in-out;
        }
        .assign-btn {
          height: 45px;
          background: #1885ad 0% 0% no-repeat padding-box;
          border-radius: 5px;
          opacity: 1;
          color: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 0px 20px;
          margin-right: 20px;
        }
        .close-btn {
          width: 100px;
          height: 45px;
          background: transparent;
          border-radius: 5px;
          opacity: 1;
          color: #1885ad;
          display: flex;
          align-items: center;
          justify-content: center;
          border: 1px solid #1885ad;
        }
      }
    }
  }
  .member-management {
    .member-container {
      background: #fff;
      padding: 30px 50px;
      width: 800px;
      .member-header {
        width: 100%;
        padding-bottom: 30px;
        h3 {
          text-align: center;
        }
      }
      .member-search-widget {
        display: grid;
        grid-template-columns: 48% 48%;
        grid-column-gap: 20px;
        padding-bottom: 30px;
        position: relative;
        .search-container {
          border: 1px solid #ccc;
          height: 45px;
          display: flex;
          align-items: center;
          padding: 0px 10px;
          border-radius: 5px;
          img {
            width: 25px;
            height: 25px;
          }
          input {
            height: 45px;
            width: 100%;
            padding-left: 15px;
            outline: none;
          }
        }
        .search_dropdown__body {
          position: absolute;
          top: 45px;
          width: 48%;
          background: #fff;
          z-index: 999;
          box-shadow: 0px 4px 7px #ccc;
          height: 250px;
          overflow-y: auto;
          border-radius: 5px;
          .dropdown__item {
            display: flex;
            align-items: center;
            border-bottom: 1px solid #e8e8e8;
            padding: 20px 10px;
            cursor: pointer;
            &:hover {
              background: #e8e8e8;
            }
            img {
              height: 30px;
              width: 30px;
              object-fit: cover;
              margin-right: 15px;
              border-radius: 50%;
            }
            .text {
              span {
                font-size: 15px;
              }
            }
          }
        }
        .invite-option {
          display: flex;
          align-items: center;
          justify-content: space-between;
          span {
            color: #b3b3b3;
          }
          .invite-btn {
            width: 127px;
            height: 45px;
            background: #1890a9 0% 0% no-repeat padding-box;
            border-radius: 4px;
            color: #fff;
            outline: none;
          }
        }
      }
      .member-body {
        .member-body-title {
          font-size: 12px;
          color: #031019;
        }
        .member-fieldset {
          border: 1px solid #c2c2c2;
          border-radius: 5px;
          padding: 15px;
          .collaboraters-widget {
            padding: 10px 0px;
            display: flex;
            flex-wrap: wrap;
            .item {
              background: #1ba5a4 0% 0% no-repeat padding-box;
              border-radius: 20px;
              display: flex;
              align-items: center;
              padding: 4px 4px;
              margin-right: 8px;
              margin-bottom: 8px;
              position: relative;
              .profile-img {
                width: 26px;
                height: 26px;
                border-radius: 50%;
                margin-right: 5px;
              }
              .name {
                color: #fff;
                margin-right: 10px;
              }
              .remove-member-btn {
                background: crimson;
                border-radius: 50%;
                height: 20px;
                width: 20px;
                display: flex;
                align-items: center;
                justify-content: center;
                position: absolute;
                top: -11px;
                right: -7px;
              }
            }
          }
        }
        .sectected-member-count {
          font-size: 14px;
          color: #6e6e6e;
          margin-top: 10px;
          display: block;
        }
      }
      .member-managment-option {
        padding-top: 20px;
        display: flex;
        justify-content: flex-start;
        .btn-save {
          width: 100px;
          height: 45px;
          background: #1890a9 0% 0% no-repeat padding-box;
          border-radius: 4px;
          color: #fff;
          outline: none;
          margin-right: 20px;
          display: center;
          justify-content: center;
        }
        .btn-back {
          height: 45px;
          border-radius: 4px;
          color: #1890a9;
          outline: none;
        }
      }
    }
  }
}

.input-flex {
  display: flex;
}
</style>